<template lang="pug">
  .operator-expenses
    .operator-expenses__title.semibold Расходы операторов на создание новых объектов
    .operator-expenses__top
      select.select.operator-expenses__select(@change="changeRegionalOperator")
        option(:disabled="Boolean(regionalOperator.length)") Региональный оператор
        option(
          v-for="item in regionalOperators"
          :key="item.id"
          :data-id="item.id"
          v-html='item.name'
        )
      div.semibold(v-if='operators.length') Сумма, руб: {{sum}}
    .table(v-if='operators.length' )
      .table__row
        .table__col.table__head.half-width Операторы:
        .table__col.table__head.half-width Сумма планируемого объема необходимых капитальных вложений для строительства, руб:
      .table__row(v-for='item in operators' :key='item.id')
        .table__col.half-width {{item.name}}
        .table__col.half-width {{item.sum}}
    div(v-if='Boolean(regionalOperator.length) && !operators.length' ) Нет данных
</template>

<script>
import { tko, analytic } from '@/api/api-endpoints'

export default {
  data: () => ({
    regionalOperators: [],
    regionalOperator: '',
    regionalOperatorId: '',
    operators: [],
  }),
  computed: {
    sum() {
      return this.operators.reduce((acc, item) => {
        acc += Number(item.sum)
        return acc
      }, 0)
    },
  },
  watch: {
    regionalOperatorId() {
      this.getRegionalOperator()
    },
  },
  methods: {
    async getRegionalOperators() {
      this.regionalOperators = (
        await this.$store.dispatch('updateUrlEndpoint', {
          endpoint: tko.regionalOperators(),
        })
      ).data.data
    },
    async getRegionalOperator() {
      this.operators = (
        await this.$store.dispatch('updateUrlEndpoint', {
          endpoint: analytic.operator({
            query: { regional_operator_id: this.regionalOperatorId },
          }),
        })
      ).data
    },
    changeRegionalOperator(e) {
      this.regionalOperator = e.target.value
      this.regionalOperatorId =
        this.regionalOperators[e.target.selectedIndex - 1]?.id
    },
  },
  created() {
    this.getRegionalOperators()
  },
}
</script>
<style scoped lang="scss">
.half-width {
  width: 50%;
}
</style>
